import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpStatusCode } from '../shared/constants/http-status-code.enum';
import { FetchStrategy } from '../shared/instrumentation/instrumented-http.service';
import { SERVICE_WORKER_ENABLED } from './service-worker-enabled.injection-token';
import { serviceWorkerFetchStrategyHeader } from './service-worker-fetch-strategy-header.constant';

/**
 * This class will set a custom `CacheMiss` HTTP status code and status text for
 * responses that went to access the Service Worker cache, but nothing was available.
 */
@Injectable()
export class ServiceWorkerCacheMissStatusInterceptor implements HttpInterceptor {
    constructor(
        @Inject(SERVICE_WORKER_ENABLED) private readonly serviceWorkerEnabled: boolean
    ) {
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.serviceWorkerEnabled) {
            return next.handle(request);
        }

        const isCacheOnly = request.headers.get(serviceWorkerFetchStrategyHeader) === FetchStrategy.CacheOnly;

        if (!isCacheOnly) {
            return next.handle(request);
        }

        return next.handle(request).pipe(
            catchError(httpError => {
                if (!(httpError instanceof HttpErrorResponse)) {
                    throw httpError;
                }

                if (httpError.status !== HttpStatusCode.Unknown) {
                    throw httpError;
                }

                // Convert a cache miss to custom status code
                throw new HttpErrorResponse({
                    error: httpError.error,
                    headers: httpError.headers,
                    status: HttpStatusCode.CacheMiss,
                    statusText: HttpStatusCode[HttpStatusCode.CacheMiss],
                    url: httpError.url
                });
            })
        );
    }
}
